import { useState } from 'react'
import { Alert, Icon, Text, FlexRow } from '@/ui'
import { AcceptButton } from './Styles'
import { Trans } from 'react-i18next'

let handleTimeout
const SuperWarning = ({
  description,
  title,
  mutation,
  onCancel,
  t,
  successText,
  onSubmit,
  acceptButtonText,
  acceptedText,
}) => {
  const [alertType, setAlertType] = useState('error')
  const [animationState, setAnimationState] = useState('initial')

  const handleAccepted = async () => {
    setAnimationState('accepted')
    setTimeout(() => {
      setAnimationState('revealButton')
    }, 150)
    await mutation()
    setAnimationState('done')
    setAlertType('success')
  }

  const countDown = (startTimeout, cancelTimeout) => {
    clearTimeout(handleTimeout)
    if (cancelTimeout) {
      if (animationState === 'accepting') {
        setAnimationState('initial')
      }
    }
    if (startTimeout) {
      handleTimeout = setTimeout(() => {
        handleAccepted()
      }, 3000)
    }
  }
  return (
    <Alert
      title={animationState === 'done' ? null : title}
      message={
        animationState === 'done' ? (
          successText
        ) : (
          <>
            {description}
            <FlexRow
              padding="20px 0 45px 0"
              flexDirection="column"
              alignItems="center">
              <Trans>
                <Text.P>This action is irreversible.</Text.P>
                <Text.P>
                  Hold down button for
                  <strong> 3 seconds </strong>
                  to confirm deletion of data
                </Text.P>
              </Trans>
            </FlexRow>
          </>
        )
      }
      type={alertType}
      hideCancelButton={animationState === 'done'}
      onCancel={onCancel}
      disabled={!['initial', 'done'].includes(animationState)}
      AcceptButton={() => (
        <AcceptButton
          done={animationState === 'done'}
          revealButton={animationState === 'revealButton'}
          accepted={animationState === 'accepted'}
          accepting={animationState === 'accepting'}
          initial={animationState === 'initial'}
          disabled={['revealButton', 'accepted'].includes(animationState)}
          onMouseUp={() => {
            if (animationState !== 'done') {
              countDown(false, true)
            }
          }}
          onMouseLeave={() => {
            if (animationState !== 'done') {
              countDown(false, true)
            }
          }}
          onClick={() => {
            if (animationState === 'done') {
              onSubmit()
            }
          }}
          onMouseDown={async () => {
            if (animationState !== 'done') {
              setAnimationState('accepting')
              countDown(true, false)
            }
          }}>
          {!['revealButton', 'done'].includes(animationState) && (
            <span>
              {acceptButtonText ?? t('Delete')}{' '}
              <Icon name="icon-trash" color="#fff" />
            </span>
          )}
          {animationState === 'revealButton' && <span>{acceptedText}</span>}
          {animationState === 'done' && <span>{t('Close')}</span>}
        </AcceptButton>
      )}
    />
  )
}

export default SuperWarning
